import React, { PureComponent } from 'react';
import { StyleSheet, Text, Pressable, View } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import { OPComponent, DateUtils } from '../../components';

import COMMON_STYLES from './calendar_item_styles';

export default class ItemButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  handlePress = () => {
    this.props.onPress(this.props.item);
  };

  render() {
    let { item, displayType, isMilitaryEmployer } = this.props;

    let timeStr = 'All Day';
    if (!item.allDay) {
      const startTime = isMilitaryEmployer
        ? DateUtils.formatTimeStringMilitary(item.startDate)
        : DateUtils.formatTimeString(item.startDate);
      const endTime = isMilitaryEmployer
        ? DateUtils.formatTimeStringMilitary(item.endDate)
        : DateUtils.formatTimeString(item.endDate);
      timeStr = `${startTime} - ${endTime}`;
    }

    return (
      <Pressable style={styles.buttonContainer} onPress={this.handlePress}>
        <View
          style={[
            THEME.textBubble,
            THEME.textBubbleSelected,
            { alignSelf: 'flex-start', paddingHorizontal: 10 },
          ]}
        >
          <Text style={[THEME.textBubbleText]}>{timeStr}</Text>
        </View>

        <Text numberOfLines={__WEB__ ? 3 : 2} ellipsizeMode="tail" style={[styles.nameText]}>
          {displayType === 'caseName' && (
            <Text style={THEME.textBold}>{`${item.caseName} - `}</Text>
          )}
          {item.eventName}
        </Text>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  ...COMMON_STYLES,
});
